import { useState, useEffect } from 'react';

let cachedPlayers = null;
let fetchPromise = null;

export function usePWHLPlayers() {
  const [players, setPlayers] = useState(cachedPlayers || []);
  const [loading, setLoading] = useState(!cachedPlayers);

  useEffect(() => {
    if (cachedPlayers) {
      setPlayers(cachedPlayers);
      setLoading(false);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = fetch('https://pwhl.unsupervisedbias.com/api/v1/players?page_size=500')
        .then(r => r.json())
        .then(data => {
          const list = data.players || data.results || (Array.isArray(data) ? data : []);
          cachedPlayers = list;
          return list;
        })
        .catch(() => {
          fetchPromise = null;
          return [];
        });
    }

    fetchPromise.then(list => {
      setPlayers(list);
      setLoading(false);
    });
  }, []);

  return { players, loading };
}
